import React, { useEffect } from "react";
import Categories from "../components/Categories";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Products from "../components/Products";
import Hero from "../components/Hero";
import Solution from "../components/Solution";
import ConnectTheWorld from "../components/ConnectTheWorld";
import AboutUs from "../components/AboutUs";
import Blogs from "../components/Blogs";
import NavMini from "../components/NavMini";

const Home = () => {

  return (
    <div>
      {/* <Navbar /> */}
      {/* <NavMini /> */}
      <Hero />

<div style={{
  height: '50vh',
  backgroundColor: '#f4f4f4',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  padding: '20px'
}}>
  <h1 style={{ fontSize: '48px', color: '#333', marginBottom: '10px' }}>
    Coming Soon
  </h1>
  <p style={{ fontSize: '20px', color: '#777', marginBottom: '20px' }}>
    We’re working on something amazing. Stay tuned!
  </p>
  <p style={{ fontSize: '16px', color: '#555', marginBottom: '5px' }}>
    Contact us at: <a href="mailto:info@supramaxglobal.com" style={{ color: '#00526F' }}>
      info@supramaxglobal.com
    </a>
  </p>
  <p style={{ fontSize: '16px', color: '#555' }}>
    Address: 13500 W AIRPORT BLVD STE B2223, SUGAR LAND, TX 77498
  </p>
</div>

      {/* <Categories /> */}
      {/* <Solution /> */}
      {/* <ConnectTheWorld /> */}
      {/* <AboutUs /> */}
      {/* <Blogs /> */}
      {/* <Footer /> */}
    </div>
  );
};

export default Home;
